import React from "react";
import { useState, useEffect } from "react";
import api from "../services/api";
import { Link, useNavigate, useParams } from "react-router-dom";
function CalfMenuItem(props) {
  const [status, setStatus] = useState({});
  const navigate = useNavigate();
  const calf = props.props.calf;
  const index = props.props.index;
  const length = props.props.length;
  const getStatus = () => {
    api.get("/health/status/" + calf.pk_calf)
      .then((response) => {
        setStatus(response.data[0]);
      })
      .catch((error) => {
        console.error("There was an error getting status of a calf!", error);
      });
  };

  useEffect(() => {
    getStatus();
  }, []);
  return (
    <div>
      <div
        className={
          "flex items-center w-full py-3 " +
          (index % 2 ? "bg-white dark:bg-slate-900 " : "bg-stone-50 dark:bg-slate-800/30 ") +
          (length === index + 1 ? "rounded-b-lg" : "")
        }
      >
        <div className="ml-3 flex w-1/4 flex-col">
          <span className="font-medium dark:text-white">{calf.name}</span>
          <span className="text-sm text-stone-400 dark:text-slate-400">
            {new Date(calf.birthdate).toLocaleString("default", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}
          </span>
        </div>
        <div className="flex flex-col ml-3 w-1/4">
          <span className="text-sm font-medium text-stone-500 border border-stone-200 rounded-full bg-stone-100 py-1 px-2 dark:border-slate-600 dark:text-slate-300 dark:bg-slate-800 w-fit">
            {calf.sex === "m" ? "Mâle" : "Femelle"} {calf.sexe === "m" ? "♂" : "♀"}
          </span>
        </div>
        <div className="">
          <div
            className={
              "rounded-full bg-emerald-100 px-2 dark:bg-emerald-900/30 " +
              (status.count === 0 && calf.vitality != "mort" ? "" : "hidden")
            }
          >
            <span className="text-sm font-medium text-emerald-600 dark:text-emerald-300">
              En bonne santé
            </span>
          </div>
          <div
            className={
              "rounded-full bg-red-100 px-2 dark:bg-red-900/30 " +
              (status.count > 0 && calf.vitality != "mort" ? "" : "hidden")
            }
          >
            <span className="text-sm font-medium text-red-600 dark:text-red-300">Malade</span>
          </div>
          <div
            className={
              "rounded-full bg-stone-200 px-2 dark:bg-slate-700 " +
              (calf.vitality === "mort" ? "" : "hidden")
            }
          >
            <span className="text-sm font-medium text-stone-500 dark:text-slate-300">Mort</span>
          </div>
        </div>
        <div className="mr-3 flex justify-end flex-grow">
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="h-5 w-5 text-stone-500 dark:text-slate-400"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.25 4.5l7.5 7.5-7.5 7.5"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CalfMenuItem;
